import { render, staticRenderFns } from "./PanelLeft.vue?vue&type=template&id=209c3906&lang=pug&"
import script from "./PanelLeft.vue?vue&type=script&lang=js&"
export * from "./PanelLeft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports